module.exports = __webpack_public_path__ + "img/4-min.ad61f0b0.jpg";